import styled, { css } from 'styled-components';
import { gridRowCenter } from 'theme/mixins';
import Paper from 'components/layout/paper/paper';

export const Wrapper = styled.div`
    ${gridRowCenter};
    width: 100%;
    height: 100%;
    background-color: ${({ theme }) => theme.branding.gray.darker};
    color: ${({ theme }) => theme.branding.white.main};
`;

export const PaperStyled = styled(Paper)(
    ({ theme }) => css`
        min-width: 400px;
        ${theme.gradients[0]};
    `,
);
